import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/attritionAndCancelReasonsSaga";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import LearnMore from "../../../../components/learnMore/learnMore";
import { SingleDatePicker } from "./smartComponents/SingleDatePicker";
import { MembershipTypes } from "./smartComponents/MembershipTypes";
import { DataPoints } from "./smartComponents/DataPoints";
import { YearOverYearChart } from "./smartComponents/YearOverYearChart";
import PieCharts from "./smartComponents/PieCharts";
import { UpdateBtns } from "./smartComponents/UpdateBtns";

import "./styles.scss";

export const AttritionAndCancelReasonsModule = (props) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.attritionAndCancelReasons.isLoading);
  const initialRequest = useSelector((state) => state.attritionAndCancelReasons.initialRequest);
  const updatesLoading = useSelector((state) => state.attritionAndCancelReasons.updatesLoading);
  const membershipTypes = useSelector(
    (state) => state.attritionAndCancelReasons.selectedFilters.membership_types
  );

  const iLearnContent = useSelector((state) => state.attritionAndCancelReasons.iLearnContent);

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  return (
    <SectionToggle
      autoHeight
      isLoading={isLoading}
      title={iLearnContent.title}
      learnMore={<LearnMore title={iLearnContent.title} content={iLearnContent.body} html />}
      content={
        <div id="attritionAndCancelReasonsModule">
          <div id="module-date-filters">
            {membershipTypes.length ? (
              <div id="override-edit-selection-bar" className="edit-selections-bar">
                <div className="section">
                  <div className="filters-wrapper">
                    <div>
                      <MembershipTypes />
                    </div>
                    <SingleDatePicker />
                    <UpdateBtns />
                  </div>
                </div>

                {updatesLoading ? (
                  <LoadingAnimation text="Updating data..." />
                ) : (
                  <>
                    <div className="section">
                      <DataPoints />

                      <YearOverYearChart />
                    </div>
                    <div className="section">
                      <PieCharts />
                    </div>
                  </>
                )}
              </div>
            ) : (
              <p className="error">No data available</p>
            )}
          </div>
        </div>
      }
    />
  );
};
